interface InsertionResult {
    text: string;
    caret: number;
}

export function insertAtSelection(
    text: string,
    selectionStart: number,
    selectionEnd: number,
    insertion: string,
): InsertionResult {
    const start = Math.min(selectionStart, text.length);
    const end = Math.min(Math.max(selectionEnd, start), text.length);

    return {
        text: `${text.slice(0, start)}${insertion}${text.slice(end)}`,
        caret: start + insertion.length,
    };
}
